/* eslint-disable array-callback-return */
import React from 'react';

export default function Standings(props) {
    const standings = props.standings;
    const players = props.db.players;

    console.log('standings rendered')
    console.log(standings);

    const leaderboard = standings.map((userObj, index) => {
        return (
            <tr key={userObj.name + "_" + index}>
                <td>{userObj.name}</td>
                <td>{userObj.Rd1}</td>
                <td>{userObj.Rd2}</td>
                <td>{userObj.S16}</td>
                <td>{userObj.E8}</td>
                <td>{userObj.F4}</td>
                <td>{userObj.C}</td>
                <td>{userObj.Total}</td>
            </tr>
        )
    })

    const rosters = standings.map(userObj => {
        var roster = userObj.roster;
        return (
            <table className="roster-table">
            <tr className="roster-teamname" key={userObj.team+'_roster'}><td>{userObj.name}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>

            {
                roster.map((playerObj, index) => {
                    var fname = playerObj.name.split(",")[1].trim();
                    var lname = playerObj.name.split(",")[0].trim();
                    var name = `${fname} ${lname}`;
                    console.log(name);

                    return (
                        <tr key={playerObj.pid + "_" + index}>
                            <td>{name}</td>
                            <td>{playerObj.school}</td>
                            <td>{playerObj.Rd1}</td>
                            <td>{playerObj.Rd2}</td>
                            <td>{playerObj.S16}</td>
                            <td>{playerObj.E8}</td>
                            <td>{playerObj.F4}</td>
                            <td>{playerObj.C}</td>
                            <td>{playerObj.Total}</td>
                        </tr>
                    ) 
                })

            }

            {
                players.filter(x => x.team === userObj.team && !roster.find(r => r.pid === x.pid) ).map((playerObj, index) => {
                    var fname = playerObj.player.split(",")[1].trim();
                    var lname = playerObj.player.split(",")[0].trim();
                    var name = `${fname} ${lname}`;
                    console.log(name);

                    return (
                        <tr key={playerObj.pid + "_" + index}>
                            <td>{name}</td>
                            <td>{playerObj.school}</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                    ) 
                })
            }

            <tr className="roster-teamname" key={userObj.team+'_rostertotal'}><td></td><td></td><td>{userObj.Rd1}</td><td>{userObj.Rd2}</td><td>{userObj.S16}</td><td>{userObj.E8}</td><td>{userObj.F4}</td><td>{userObj.C}</td><td>{userObj.Total}</td></tr>

            </table>
        )
        
    })

    return (
        <div className="standings-wrapper">
            <div className="leaderboard translucent-box">
                <h2>Standings</h2>
                <table>
                <thead><tr><th>Team</th><th>Rd1</th><th>Rd2</th><th>S16</th><th>E8</th><th>F4</th><th>C</th><th>Total</th></tr></thead>
                <tbody>
                    { leaderboard }
                </tbody>
                </table>
            </div>
            <div className="rosters translucent-box">
                <h2>Rosters</h2>
                <table>
                    <tr><td>Team</td><td>School</td><td>Rd1</td><td>Rd2</td><td>S16</td><td>E8</td><td>F4</td><td>C</td><td>Total</td></tr>
                </table>
                { rosters }
            </div>
        </div>
    )
}